import { components } from "@certn/legacy-api/generated-schemas/people";

export type ValidationRuleType<T = components["schemas"]["ValidationRule"]> = {
  rule?: T;
  isValid: (data: any) => boolean;
};

export enum Rules {
  REQUIRE_EMPLOYMENT = "REQUIRE_EMPLOYMENT",
  REQUIRE_X_YEARS_EMPLOYMENT_HISTORY = "REQUIRE_X_YEARS_EMPLOYMENT_HISTORY",
  REQUIRE_EMPLOYMENT_REFERENCES = "REQUIRE_EMPLOYMENT_REFERENCES",
  REQUIRE_EMPLOYMENT_REFERENCE_WITHIN_YEARS = "REQUIRE_EMPLOYMENT_REFERENCE_WITHIN_YEARS",
  REQUIRE_EMPLOYMENT_ADDRESS = "REQUIRE_EMPLOYMENT_ADDRESS",
  REQUIRE_EDUCATION = "REQUIRE_EDUCATION",
  MAXIMUM_EMPLOYMENT_REFERENCES = "MAXIMUM_EMPLOYMENT_REFERENCES",
  REQUIRE_ADDRESS = "REQUIRE_ADDRESS",
  REQUIRE_CANADIAN_ADDRESS = "REQUIRE_CANADIAN_ADDRESS",
  REQUIRE_X_YEARS_ADDRESS_HISTORY = "REQUIRE_X_YEARS_ADDRESS_HISTORY",
  REQUIRE_UNITED_STATES_ADDRESS = "REQUIRE_UNITED_STATES_ADDRESS",
  REQUIRE_CREDENTIALS = "REQUIRE_CREDENTIALS",
  REQUESTED_INTL_ADDRESSES = "REQUESTED_INTL_ADDRESSES",
}
